import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Box
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ImageUpload } from "../../ImageUpload";

const BasicInformation = ({ formData, onFormChange, isComplete = false }) => {
  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="subtitle1">Basic Information</Typography>
          {isComplete && <CheckCircleIcon color="success" />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <TextField
          fullWidth
          label="Title *"
          margin="normal"
          value={formData.title}
          onChange={(e) => onFormChange("title", e.target.value)}
          required
        />

        <Box sx={{ mt: 2, mb: 2 }}>
          <Typography variant="subtitle2" gutterBottom>
            Icon
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Drag and drop an image or click to select an image
          </Typography>
          <ImageUpload
            image={formData.iconUrl}
            onChange={({ target }) => onFormChange("iconUrl", target.value)}
            name="iconUrl"
            imageAlt="spending goal icon"
            ratio="1:1"
            sx={{ width: "200px", height: "200px" }}
          />
        </Box>

        <TextField
          fullWidth
          label="Spending Goal Key"
          margin="normal"
          value={formData.spendingGoalKey}
          onChange={(e) => onFormChange("spendingGoalKey", e.target.value)}
          helperText="Unique identifier for the spending goal"
        />

        <TextField
          label="Order"
          margin="normal"
          type="number"
          value={formData.order}
          onChange={(e) => onFormChange("order", e.target.value)}
          helperText="Ordering priority (optional)"
        />

        <TextField
          fullWidth
          label="FAQ"
          margin="normal"
          multiline
          rows={4}
          value={formData.faq}
          onChange={(e) => onFormChange("faq", e.target.value)}
          helperText="Frequently asked questions about this spending goal"
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default BasicInformation;
